import { addDoc, collection, onSnapshot, serverTimestamp } from 'firebase/firestore';
import { isValidNotifyEmail } from './hamburgerMenu';

export const FEATURE_NOTIFY_COLLECTION = 'featureNotifySignups';

export async function submitFeatureNotify(db, { email, feature, uid = null } = {}) {
  const clean = String(email || '').trim().toLowerCase();
  if (!isValidNotifyEmail(clean)) {
    throw new Error('Enter a valid email address.');
  }
  const label = String(feature || '').trim();
  if (!label) {
    throw new Error('Missing feature name.');
  }
  await addDoc(collection(db, FEATURE_NOTIFY_COLLECTION), {
    email: clean,
    feature: label,
    uid: uid || null,
    createdAt: serverTimestamp(),
  });
  return { email: clean, feature: label };
}

export function featureNotifyCreatedAtMs(createdAt) {
  if (!createdAt) return 0;
  if (typeof createdAt.toMillis === 'function') return createdAt.toMillis();
  if (typeof createdAt.seconds === 'number') return createdAt.seconds * 1000;
  const parsed = new Date(createdAt).getTime();
  return Number.isFinite(parsed) ? parsed : 0;
}

export function formatFeatureNotifyTime(createdAt) {
  const ms = featureNotifyCreatedAtMs(createdAt);
  if (!ms) return '—';
  return new Date(ms).toLocaleString();
}

export function groupFeatureNotifySignups(rows = []) {
  const byFeature = new Map();
  rows.forEach((row) => {
    const feature = String(row?.feature || 'Unknown').trim() || 'Unknown';
    if (!byFeature.has(feature)) byFeature.set(feature, []);
    byFeature.get(feature).push(row);
  });
  return [...byFeature.entries()]
    .sort((a, b) => a[0].localeCompare(b[0]))
    .map(([feature, signups]) => ({
      feature,
      count: signups.length,
      signups: signups.slice().sort((a, b) => featureNotifyCreatedAtMs(b.createdAt) - featureNotifyCreatedAtMs(a.createdAt)),
    }));
}

export function subscribeFeatureNotifySignups(db, callback, onError) {
  return onSnapshot(
    collection(db, FEATURE_NOTIFY_COLLECTION),
    (snap) => {
      callback(snap.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() })));
    },
    (err) => {
      console.error('featureNotifySignups', err);
      onError?.(err);
      callback([]);
    }
  );
}
